import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {Api} from '@shared/constants/common-field.constants';
import {take, takeUntil} from 'rxjs/operators';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {forkJoin, Subject} from 'rxjs';
import {Contact} from '@features/contacts/store/contact.model';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ExpertServiceModel, ExpertServiceWorkSpace} from '@features/expert-services/models/expert-services.model';
import {StringUtility} from '@shared/utility/string-utility';
import {SmartGridService} from '@core/services/smart-grid.service';

@Component({
    standalone: false,
    selector: 'app-create-consultant-dialog',
  templateUrl: './create-consultant-dialog.component.html',
  styleUrls: ['./create-consultant-dialog.component.scss']
})
export class CreateConsultantDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  expertServicesModels: ExpertServiceModel[] = [];
  private selectedExpertServicesModels: ExpertServiceModel[] = [];
  private selectedContacts: Contact[] = [];
  notConsultantContacts: Contact[] = [];
  selectorForm: FormGroup;
  contacts: object = {};
  filteredContacts: any[];
  filterForm: FormGroup;
  serviceFilterForm: FormGroup;
  contactFieldDefinitions: any;
  sourceType = 'Platform-Contact-V2';
  unsubscribe$ = new Subject<void>();

  constructor(private platformQueryService: PlatformQueryService,
              private snackBarService: SnackBarService,
              private smartGridService: SmartGridService,
              private formBuilder: FormBuilder) {
    this.filterForm = this.formBuilder.group({
      searchText: ['']
    });
    this.serviceFilterForm = this.formBuilder.group({
      searchText: ['']
    });
  }

  ngOnInit(): void {
    this.getExpertServiceModels();
    this.getContactsWithoutConsultantRoles();
  }

  onOkClicked(): boolean {
    if (this.selectedContacts.length > 0 && this.selectedExpertServicesModels.length > 0) {
      this.data.input.contacts = this.selectedContacts.map(o => o['user']);
      this.data.input.expertServicesModels = this.selectedExpertServicesModels.map(o => o.id);
      return true;
    }
    this.snackBarService.showError('You must select contacts and services');
    return false;
  }

  private getExpertServiceModels() {
    const query = new PlatformQuery();
    query.name = 'ExpertServiceModelsQuery';
    query.api = Api.MarketPlace;
    query.fieldValues['IsConsultant'] = true;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {
        this.expertServicesModels = response.fieldValues['ExpertServiceModels'];
        this.expertServicesModels.forEach(o => o.isVisible = true);
        this.serviceFilterForm.valueChanges.subscribe(value => {
          if (this.expertServicesModels && this.expertServicesModels.length > 0) {
            this.onServiceFilterValueChange(value);
          }
        });
      }
    });
  }
  private getContactsWithoutConsultantRoles() {
    const query = new PlatformQuery();
    query.name = 'ContactsNotMatchedByRoleQuery';
    query.api = Api.Contacts;
    query.fieldValues['Role'] = 'Consultant';
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {
        this.notConsultantContacts = response.fieldValues['Contacts'];
        const modifiedResponse = this.notConsultantContacts.map(contact => {
          const firstChar = contact.name.charAt(0);
          contact['initial'] = firstChar.toUpperCase();
          contact.email = contact.email.toLowerCase();
          return contact;
        });
        const groupContactsArray = [];
        const groupedContacts = modifiedResponse.reduce(
          (result, item) => ({
            ...result,
            [item['initial']]: [
              ...(result[item['initial']] || []),
              item,
            ],
          }),
          {},
        );
        console.log('Group Contacts', groupedContacts);
        Object.keys(groupedContacts).sort().forEach(key => {
          groupContactsArray.push({
            key: key,
            visibleItemCount: groupedContacts[key].length,
            users: groupedContacts[key].map(item => {
              const isChecked = false, isDirty = false;
              const disableSelection = false;
              return {
                isVisible: true,
                user: item,
                isChecked: isChecked,
                isDirty: isDirty,
                disableSelection: disableSelection,
              };
            })
          });
        });
        this.contacts['userGroups'] = groupContactsArray;
        this.filteredContacts = groupContactsArray;
        this.filterForm.valueChanges.subscribe(value => {
          if (this.contacts['userGroups'] && this.contacts['userGroups'].length > 0) {
            this.onFilterValueChange(value);
          }
        });
      }
    });
  }
  private onFilterValueChange(value: any) {
    const wordArray = value.searchText.split(' ').map(word => word.toLowerCase());
    this.searchContact(wordArray);
  }
  private onServiceFilterValueChange(value: any) {
    const wordArray = value.searchText.split(' ').map(word => word.toLowerCase());
    this.searchService(wordArray);
  }
  searchContact(keyWords) {
    this.contacts['userGroups'].forEach(contactGroup => {
      contactGroup.users.forEach(contact => {
        let foundKeywords = true;
        keyWords.forEach(word => {
          let foundkeyword = false;
          if ( contact.user.email.includes(word) || contact.user.name.includes(word) ) {
            foundkeyword = true;
          }
          if (!foundkeyword) {
            foundKeywords = false;
            return;
          }
        });
        if (!contact.isVisible && foundKeywords) {
          contactGroup.visibleItemCount++;
        } else if (contact.isVisible && !foundKeywords) {
          contactGroup.visibleItemCount--;
        }
        contact.isVisible = foundKeywords;
      });
    });
  }
  searchService(keyWords) {
    this.expertServicesModels.forEach(service => {
      let foundKeywords = true;
      keyWords.forEach(word => {
        let foundkeyword = false;
        if ( service.title.includes(word) ) {
          foundkeyword = true;
        }
        if (!foundkeyword) {
          foundKeywords = false;
          return;
        }
      });
      service.isVisible = foundKeywords;
    });
  }
  onCheckBoxChange($event: MatCheckboxChange, item: any) {
    console.log($event, item);
    item.isChecked = $event.checked;
    if ($event.checked) {
      const idx = this.selectedExpertServicesModels.findIndex(o => o.id === item.id);
      if (idx === -1) {
        this.selectedExpertServicesModels.push(item);
      } else {
        this.selectedExpertServicesModels[idx] = {...item};
      }
    } else {
      this.selectedExpertServicesModels = this.selectedExpertServicesModels.filter(p => p.id !== item.id);
    }
    this.data.isDisabledOkButton = false;
  }
  onContactCheckBoxChange($event: MatCheckboxChange, item: Contact) {
    console.log($event, item);
    item.isChecked = $event.checked;
    if ($event.checked) {
      const emails = this.selectedContacts.findIndex(o => o.email === item.email);
      if (emails === -1) {
        this.selectedContacts.push(item);
      } else {
        this.selectedContacts[emails] = {...item};
      }
    } else {
      this.selectedContacts = this.selectedContacts.filter(p => p.email !== item.email);
    }
    this.data.isDisabledOkButton = false;
  }
  onCancelClicked(): any {
    return true;
  }
  selectAllContact() {
    // console.log('hola');
    this.contacts['userGroups'] = this.contacts['userGroups'].map(userGroup => {
      userGroup.users = userGroup.users.map(user => {
        return this.checkUser(user);
      });
      return userGroup;
    });
  }

  deselectAllContact() {
    this.contacts['userGroups'] = this.contacts['userGroups'].map(userGroup => {
      userGroup.users = userGroup.users.map(user => {
        return this.unCheckUser(user);
      });
      return userGroup;
    });
  }
  checkUser(user) {
    if (user.isChecked || !user.isVisible || user.disableSelection) {
      return user;
    }
    user.isDirty = true;
    user.isChecked = true;
    return user;
  }

  unCheckUser(user) {
    if (!user.isChecked || !user.isVisible || user.disableSelection) {
      return user;
    }
    user.isDirty = true;
    user.isChecked = false;
    return user;
  }

  ngOnDestroy(): void {
  }
}
